import JobForm from "@Organism/Home/Business/Dashboard/JobForm";
import LoadingAnimationPage from "@Organism/LoadingAnimationPage";
import AsyncErrorBoundary from "@Organism/Utils/AsyncErrorBoundary";
import { getDetailJobPost, getDropdownListUploadJob } from "@Services/home";
import { Suspense } from "react";
import { Await, defer, useLoaderData } from "react-router-dom";

export const loaderJobForm = (route) => {
  const url = new URL(route?.request?.url);
  const query = url.searchParams;
  const id = query?.get("id") || "";
  return defer({
    getDropdownList: getDropdownListUploadJob(),
    getDetailJobPost: id ? getDetailJobPost(id) : null,
  });
};

export default function JobFormPage() {
  const { getDropdownList, getDetailJobPost } = useLoaderData();

  return (
    <Suspense fallback={<LoadingAnimationPage />}>
      <Await
        resolve={getDropdownList}
        errorElement={
          <div
            style={{
              height: "100vh",
            }}
          >
            <AsyncErrorBoundary />
          </div>
        }
      >
        {(getDropdownList) => (
          <Suspense fallback={<LoadingAnimationPage />}>
            <Await
              resolve={getDetailJobPost}
              errorElement={
                <div
                  style={{
                    height: "100vh",
                  }}
                >
                  <AsyncErrorBoundary />
                </div>
              }
            >
              {(getDetailJobPost) => (
                <JobForm
                  getDropdownList={getDropdownList}
                  getDetailJobPost={getDetailJobPost || null}
                />
              )}
            </Await>
          </Suspense>
        )}
      </Await>
    </Suspense>
  );
  // return <JobForm />;
}
